module.exports = __webpack_public_path__ + "static/media/class_small_neutral.d25d7174.png";